import { OperationServiceAdapter } from '../'

export class NullOperationService extends OperationServiceAdapter<null> {
  public constructor() {
      super(null, null)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/null-operation/null-operation.service.ts